import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CrossesReferences,
  CrossReferencesOpinionOption,
} from '../../types/types';

@Injectable({
  providedIn: 'root',
})
export class CrossreferencesApiService {
  baseUrl = '/aptitude/api/crossreferences';

  constructor(private http: HttpClient) {}

  /**
   * @important This method does not comply with our standard pattern of grouping API endpoints.
   *
   * API requests need to be grouped by path - not feature.
   * This belongs under a products-api.service.ts file.
   */
  getCrossReferences(productId: number) {
    return this.http.get<Array<CrossesReferences>>(
      `/aptitude/api/products/${productId}/crossreferences`,
    );
  }

  /**
   * @deprecated Use updateOpinion with clinicalFeedback
   * @link updateOpinion
   */
  updateVote(crossReferenceId: number, opinionType: string, rfpId?: number) {
    return this.http.put(`${this.baseUrl}/${crossReferenceId}/opinion`, {
      opinionType,
      rfpId,
    });
  }

  /**
   * @deprecated Use {@link CrossReferenceGraphqlService.addCrossReferenceOpinion}
   * @description Update the vote for a crossReference.
   * @param clinicalFeedback takes in an enum key provided by getOpinionOptions
   * @link getOpinionOptions
   */
  updateOpinion(
    crossReferenceId: number,
    clinicalFeedback?: string,
    rfpId?: number,
  ) {
    return this.http.put(`${this.baseUrl}/${crossReferenceId}/opinion`, {
      rfpId,
      clinicalFeedback,
    });
  }

  /**
   * @deprecated Use {@link CrossReferenceGraphqlService.addCrossReferenceNote}
   */
  addNote(crossReferenceId: number, note: string) {
    return this.http.post(`${this.baseUrl}/${crossReferenceId}/notes`, {
      note,
    });
  }

  addCrosses(fromProductId: number, toProductId: number) {
    return this.http.post(this.baseUrl, {
      fromProductId,
      toProductId,
    });
  }
  /**
   * Get a list of options to use in the dropdown menu in the Notes tab.
   */
  getOpinionOptions(): Observable<CrossReferencesOpinionOption[]> {
    return this.http.get(`${this.baseUrl}/opinionoptions`) as Observable<
      CrossReferencesOpinionOption[]
    >;
  }
}
